export function getStoredLocationData (locationItem) {
	const {
		client_ip_address: userIP,
		ip_lookup_location: iPlookupZIP,
		saved_location: userProfile,
	} = wpProfile || {}; // eslint-disable-line no-undef
	const locationdata = JSON.parse(sessionStorage.getItem('location'));
	if (userProfile) {
		if (locationItem) {
			if (locationItem === 'userZIP') {
				return userProfile.ZIP;
			}
			if (locationItem === 'userCity') {
				return userProfile.City;
			}
			if (locationItem === 'userStateShort') {
				return userProfile.StateShort;
			}
			if (locationItem === 'userStateLong') {
				return userProfile.StateLong;
			}
			if (locationItem === 'userIP') {
				return userIP;
			}
			if (locationItem === 'userLat') {
				return userProfile.Lat;
			}
			if (locationItem === 'userLon') {
				return userProfile.Lon;
			}
		} else {
			return userProfile;
		}
	} else if (locationdata) {
		if (locationItem === 'userZIP') {
			return parseGooData(locationdata, 'userZIP');
		}
		if (locationItem === 'userIP') {
			return userIP;
		}
	} else {
		if (locationItem === 'userZIP') {
			return iPlookupZIP;
		}
		if (locationItem === 'userIP') {
			return userIP;
		}
	}
	return null;
}

function parseGooData (gooData, returnSelect) {
	if (gooData && (gooData.status !== 'ZERO_RESULTS')) {
		let gooAddress = gooData.results[0].formatted_address.split(',');
		if (returnSelect === 'userZIP') {
			return gooData.results[0].address_components[0].short_name;
		} else if (returnSelect === 'userCity') {
			if (gooAddress[0] === 'Serving the entire Chicago Area') {
				return gooAddress[1];
			} else {
				return gooAddress[0];
			}
		} else if (returnSelect === 'userStateL') {
			return gooData.results[0].address_components[3].long_name;
		} else if (returnSelect === 'userStateS') {
			let state_short = [];
			if (gooAddress[0] === 'Serving the entire Chicago Area') {
				state_short = gooAddress[2].split(' ');
				return state_short[1];
			} else {
				state_short = gooAddress[1].split(' ');
				return state_short[1];
			}
		} else if (returnSelect === 'userLat') {
			return gooData.results[0].geometry.location.lat;
		} else if (returnSelect === 'userLng') {
			return gooData.results[0].geometry.location.lng;
		}
	}
}
